import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router';
import {actionCreator, RootState} from '../_modules';
import {Handlers, State, Store} from './types';
import View from './view';


const float2Str = (coord: number | undefined): string => {
  if (coord === undefined) {
    return '';
  } else {
    return `${coord > 0 ? '+' : ''}${Math.round(coord*100) / 100}`;
  }
};


const SearchForm: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [state, setState] = React.useState<State>({
    text: '',
    inputLat: '',
    inputLng: '',
  });

  const store: Store = useSelector((rootState: RootState): Store => {
    return {
      lnglat: rootState.pointerFeature?.geometry.coordinates,
      rect: rootState.rectAngle,
      searchType: rootState.searchType,
      pointerFeature: rootState.pointerFeature,
    };
  });

  const handlers: Handlers = {
    search: () => {
      if (store.searchType === 'distance') {
        const [lng, lat] = [parseFloat(state.inputLng), parseFloat(state.inputLat)];
        setState({...state, inputLat: float2Str(lat), inputLng: float2Str(lng)});
        if (isNaN(lng) || isNaN(lat)) {
          dispatch(actionCreator.pointOnMap({lnglat: undefined}));
        } else {
          dispatch(actionCreator.pointOnMap({lnglat: [lng, lat]}));
        }
        const x = store.lnglat ? store.lnglat[0] : NaN;
        const y = store.lnglat ? store.lnglat[1] : NaN;
        const typeDistance = (isNaN(x) || isNaN(y)) ? 'k' : 'd';
        navigate(`/search?q=${state.text}&x=${x}&y=${y}&t=${typeDistance}`);
      } else if (store.searchType === 'rect') {
        const rangeX = `${store.rect.maxLngLat[0]},${store.rect.minLngLat[0]}`;
        const rangeY = `${store.rect.maxLngLat[1]},${store.rect.minLngLat[1]}`;
        navigate(`/search?q=${state.text}&x=${rangeX}&y=${rangeY}&t=r`);
      } else {
        navigate(`/search?q=${state.text}&x=${NaN}&y=${NaN}&t=k`);
      }
    },
    inputText: (e) => setState({...state, text: e.target.value}),
    changeLat: (e) => setState({...state, inputLat: e.target.value}),
    changeLng: (e) => setState({...state, inputLng: e.target.value}),
    setLngLat: () => {
      const [lng, lat] = [parseFloat(state.inputLng), parseFloat(state.inputLat)];
      setState({...state, inputLat: float2Str(lat), inputLng: float2Str(lng)});
      dispatch(actionCreator.pointOnMap({lnglat: [isNaN(lng) ? 0 : lng, isNaN(lat) ? 0 : lat]}));
    },
    switchSearchType: (target) => {
      const searchType = target == store.searchType ? 'keyword' : target;
      dispatch(actionCreator.setSearchType({searchType}));
    },
  };

  useEffect(() => {
    const lng = store.pointerFeature?.geometry.coordinates[0] || undefined;
    const lat = store.pointerFeature?.geometry.coordinates[1] || undefined;
    setState({
      ...state,
      inputLng: float2Str(lng),
      inputLat: float2Str(lat),
    });
  }, [store.pointerFeature]);

  return (
    <View {...{handlers, store, state}}/>
  );
};

export default SearchForm;
